import {Component, Element, Prop} from '@stencil/core';
import * as CookieConsent from 'vanilla-cookieconsent';

@Component({
    tag: 'physiogroup-cookiehint',
    styleUrl: 'physiogroup-cookiehint.scss'
})
export class PhysiogroupCookiehint {
    @Prop() public currentLanguage: string = 'de';
    @Element() private element: HTMLElement;

    componentDidLoad() {
        CookieConsent.run({
            root: 'body',
            autoShow: true,
            autoClearCookies: true,
            disablePageInteraction: true,
            hideFromBots: true,
            mode: 'opt-in',
            revision: 1, // increase to trigger display on consent changes

            categories: {
                necessary: {
                    enabled: true,  // this category is enabled by default
                    readOnly: true  // this category cannot be disabled
                },
                analytics: {}, // might need to configure cookie names https://cookieconsent.orestbida.com/essential/getting-started.html
                external: {}
            },

            onConsent: () => {
                if (!(window as any).im) {
                    return;
                }

                if (CookieConsent.getUserPreferences().acceptedCategories.includes('external')) {
                    (window as any).im.acceptService('all');
                } else {
                    (window as any).im.rejectService('all');
                }
            },

            onChange: () => {
                if (!(window as any).im) {
                    return;
                }

                if (CookieConsent.getUserPreferences().acceptedCategories.includes('external')) {
                    (window as any).im.acceptService('all');
                } else {
                    (window as any).im.rejectService('all');
                }
            },

            language: {
                default: this.currentLanguage,
                translations: {
                    de: {
                        consentModal: {
                            title: 'Cookie-Nutzung',
                            description: this.element.innerHTML,
                            acceptAllBtn: 'Akzeptieren',
                            acceptNecessaryBtn: 'Ablehnen',
                            showPreferencesBtn: 'Einstellungen anpassen',
                        },
                        preferencesModal: {
                            title: 'Cookie-Einstellungen',
                            savePreferencesBtn: 'Auswahl akzeptieren',
                            acceptAllBtn: 'Alle akzeptieren',
                            acceptNecessaryBtn: 'Alle ablehnen',
                            closeIconLabel: 'Schliessen',
                            sections: [
                                {
                                    title: 'Cookie-Nutzung',
                                    description: this.element.innerHTML
                                }, {
                                    title: 'Funktionale Cookies',
                                    description: 'Funktionale Cookies sind für die Funktionsfähigkeit der Website notwendig. Diese Cookies können nicht deaktiviert werden.',
                                    linkedCategory: 'necessary',
                                }, {
                                    title: 'Marketing, Analyse & Tracking Cookies',
                                    description: 'Marketing Cookies werden verwendet, um Besuchern auf Websites zu folgen und ggf. relevante Werbung anzuzeigen. Analyse Cookies helfen Website-Besitzern zu verstehen, wie Besucher mit Websites interagieren, indem Informationen anonym gesammelt und gemeldet werden.',
                                    linkedCategory: 'analytics',
                                }, {
                                    title: 'Cookies externer Anbieter',
                                    description: 'Cookies von Drittanbietern, die für die Anzeige eingebetteter Inhalte erforderlich sind. Diese können unter Umständen Ihr Verhalten nachverfolgen.',
                                    linkedCategory: 'external',
                                }
                            ]
                        }
                    },
                    en: {
                        consentModal: {
                            title: 'Cookie Usage',
                            description: this.element.innerHTML,
                            acceptAllBtn: 'Accept',
                            acceptNecessaryBtn: 'Reject',
                            showPreferencesBtn: 'Adjust Settings',
                        },
                        preferencesModal: {
                            title: 'Cookie Settings',
                            savePreferencesBtn: 'Accept Selection',
                            acceptAllBtn: 'Accept All',
                            acceptNecessaryBtn: 'Decline All',
                            closeIconLabel: 'Close',
                            sections: [
                                {
                                    title: "Cookie Usage",
                                    description: this.element.innerHTML
                                },
                                {
                                    title: "Functional Cookies",
                                    description: "Functional cookies are necessary for the website's functionality. These cookies cannot be deactivated.",
                                    linkedCategory: 'necessary',
                                },
                                {
                                    title: "Marketing, Analysis & Tracking Cookies",
                                    description: "Marketing cookies are used to track visitors across websites and display relevant advertisements. Analytical cookies help website owners understand how visitors interact with websites by collecting and reporting information anonymously.",
                                    linkedCategory: 'analytics',
                                }, {
                                    title: 'Cookies of external providers',
                                    description: 'Cookies from third parties that are required for displaying embedded content. These may potentially track your behavior.',
                                    linkedCategory: 'external',
                                }
                            ]
                        }
                    },
                }
            },

            guiOptions: {
                consentModal: {
                    layout: 'box',
                    position: 'middle center',
                    equalWeightButtons: true,
                },
                preferencesModal: {
                    layout: 'box',
                    position: 'right',
                    equalWeightButtons: true,
                }
            },
        });
    }
}
